import React from "react";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import PaginationOwn from "../_common/ownPagination";
import { formatDateTime } from "../../i18n/dateLocale";

const PhysicalCardReportTable = (props) => {
  const { t } = useTranslation();

  const headers = [
    { label: t("admin.physicalCards.report.type"), key: "type" },
    { label: t("admin.physicalCards.report.cardIdentifier"), key: "cardIdentifier" },
    { label: t("admin.physicalCards.report.venue"), key: "storeName" },
    { label: t("admin.physicalCards.report.product"), key: "productName" },
    { label: t("admin.physicalCards.report.user"), key: "userName" },
    { label: t("admin.physicalCards.report.source"), key: "source" },
    { label: t("admin.physicalCards.report.date"), key: "date" },
  ];

  return (
    <div className="table-wrapper px-3 pt-3">
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-2">
        <p className="table-type">{t("admin.physicalCards.report.title")}</p>
        <div className="d-flex align-items-center">
          <input
            className="form-control mr-2"
            placeholder={t("common.search")}
            value={props?.searchVal}
            onChange={(ev) => props?.setSearchVal(ev.target.value)}
            style={{ maxWidth: "200px" }}
          />
          {props?.allReport?.length > 0 && (
            <CSVLink
              className="btn admin-btn secondary-btn"
              data={props.allReport}
              filename={"physical-card-report.csv"}
              headers={headers}
            >
              {t("common.downloadCsv")}
            </CSVLink>
          )}
        </div>
      </div>

      <div className="table-wrapper-scroll-y table-scrollbar">
        <div className="table-own table-responsive">
          <table className="table table-striped table-hover table-admin">
            <thead className="table-head">
              <tr>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "type" ? "active" : ""} ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("type")}
                >
                  <span>{t("admin.physicalCards.report.type")}</span>{" "}
                  {props?.sortObj?.sortVal === "type" && props?.sortObj?.sortType === "aesc" && <i className="fas fa-caret-down"></i>}
                  {props?.sortObj?.sortVal === "type" && props?.sortObj?.sortType === "desc" && <i className="fas fa-caret-up"></i>}
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "cardIdentifier" ? "active" : ""} ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("cardIdentifier")}
                >
                  <span>{t("admin.physicalCards.report.cardIdentifier")}</span>{" "}
                  {props?.sortObj?.sortVal === "cardIdentifier" && props?.sortObj?.sortType === "aesc" && <i className="fas fa-caret-down"></i>}
                  {props?.sortObj?.sortVal === "cardIdentifier" && props?.sortObj?.sortType === "desc" && <i className="fas fa-caret-up"></i>}
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "storeName" ? "active" : ""} ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("storeName")}
                >
                  <span>{t("admin.physicalCards.report.venue")}</span>{" "}
                  {props?.sortObj?.sortVal === "storeName" && props?.sortObj?.sortType === "aesc" && <i className="fas fa-caret-down"></i>}
                  {props?.sortObj?.sortVal === "storeName" && props?.sortObj?.sortType === "desc" && <i className="fas fa-caret-up"></i>}
                </th>
                <th>
                  <span>{t("admin.physicalCards.report.product")}</span>
                </th>
                <th>
                  <span>{t("admin.physicalCards.report.user")}</span>
                </th>
                <th>
                  <span>{t("admin.physicalCards.report.source")}</span>
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "date" ? "active" : ""} ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                  onClick={() => props.arraySorting("date")}
                >
                  <span>{t("admin.physicalCards.report.date")}</span>{" "}
                  {props?.sortObj?.sortVal === "date" && props?.sortObj?.sortType === "aesc" && <i className="fas fa-caret-down"></i>}
                  {props?.sortObj?.sortVal === "date" && props?.sortObj?.sortType === "desc" && <i className="fas fa-caret-up"></i>}
                </th>
              </tr>
            </thead>
            <tbody className="table-body">
              {props.reportData.map((data, idx) => (
                <tr key={idx}>
                  <td>
                    {/* PR3: backend now returns three types -- linked,
                        linked-cooldown (admin retroactively linked but
                        user was in cooldown so no UT was created), and
                        anonymous (no matching user). Render each
                        distinctly so admins can spot the cooldown case. */}
                    {data.type === "linked" && (
                      <span className="table-isactive">
                        {t("admin.physicalCards.report.linked")}
                      </span>
                    )}
                    {data.type === "linked-cooldown" && (
                      <span className="table-iscooldown">
                        {t("admin.physicalCards.report.linkedCooldown")}
                      </span>
                    )}
                    {(data.type === "anonymous" || data.type === "unlinked") && (
                      <span className="table-isinactive">
                        {t("admin.physicalCards.report.unlinked")}
                      </span>
                    )}
                  </td>
                  <td>{data.cardIdentifier || t("common.na")}</td>
                  <td>{data.storeName || t("common.na")}</td>
                  <td>{data.productName || t("common.na")}</td>
                  <td>{data.userName || t("common.na")}</td>
                  <td>{data.source === "venue_issuance" ? t("admin.physicalCards.report.venueIssuance") : data.source === "bulk_upload" ? t("admin.physicalCards.report.bulkUpload") : t("common.na")}</td>
                  <td>{data.date ? formatDateTime(new Date(data.date)) : t("common.na")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {props?.totalCount > 0 && (
        <PaginationOwn
          pageSize={props?.pageSize}
          changePageSize={props?.changePageSize}
          goToPage={props?.goToPage}
          totalCount={props?.totalCount}
          currentPage={props?.currentPage}
          applicationType={props?.totalCount > 1 ? "records" : "record"}
        />
      )}
    </div>
  );
};

export default PhysicalCardReportTable;
